import axios from '../../../plugins/axios'

export default {
  get: (params) => axios.get('/api/v1/debezium-signal', { params }),
  find: (id) => axios.get(`/api/v1/debezium-signal/${id}`),
  del: (id) => axios.delete(`/api/v1/debezium-signal/${id}`),
  update: (id, data) => axios.put(`/api/v1/debezium-signal/${id}`, data),
  create: (data) => axios.post('/api/v1/debezium-signal', data),
}
